import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type IntlService from 'ember-intl/services/intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import PatientInformationTransmittedJournalEvent from 'parog-web/models/patient-information-transmitted-journal-event';

export default class TransmissionEditionComponent extends CrudJournalEventBaseComponent {
  static override forcDisplayName = 'Transmission';
  static override fullComponentId = 'transmission/edition';
  static override journalEventClass = PatientInformationTransmittedJournalEvent;

  @service declare intl: IntlService;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  <template>
    <Provider @isHeaderHidden={{true}} @forcComponent={{this}}>
      <:content as |Form|>
        <div class='field'>
          <Form.TextArea
            @labelName='Transmission'
            @propertyName='information'
            @displaySubText={{true}}
            @subText='Ces transmissions sont partagées entre les professionnels
        de santés uniquement et donnent des informations importantes sur le patient'
          />
        </div>
      </:content>
    </Provider>
  </template>
}
